module.exports = __webpack_public_path__ + "img/right-arrow.1747b9ad.svg";